package com.dwarshb.bms

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.AddCircle
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.LocationCity
import androidx.compose.material.icons.filled.Payment
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.material3.AlertDialogDefaults
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DatePickerDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.TextField
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.SnapshotStateList
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.lifecycle.viewmodel.compose.viewModel
import busmanagementsystem.composeapp.generated.resources.Res
import busmanagementsystem.composeapp.generated.resources.back_to_home
import busmanagementsystem.composeapp.generated.resources.button_add_stop
import busmanagementsystem.composeapp.generated.resources.button_customize_seat_layout
import busmanagementsystem.composeapp.generated.resources.button_next_steps
import busmanagementsystem.composeapp.generated.resources.coach_category_ac
import busmanagementsystem.composeapp.generated.resources.coach_category_non_ac
import busmanagementsystem.composeapp.generated.resources.coach_type_seater
import busmanagementsystem.composeapp.generated.resources.coach_type_sleeper
import busmanagementsystem.composeapp.generated.resources.content_desc_date
import busmanagementsystem.composeapp.generated.resources.create_new_trip_subtitle
import busmanagementsystem.composeapp.generated.resources.create_new_trip_title
import busmanagementsystem.composeapp.generated.resources.dialog_action_lock_seat
import busmanagementsystem.composeapp.generated.resources.dialog_action_unlock_seat
import busmanagementsystem.composeapp.generated.resources.email
import busmanagementsystem.composeapp.generated.resources.error
import busmanagementsystem.composeapp.generated.resources.hint_add_stops
import busmanagementsystem.composeapp.generated.resources.label_arrival_date
import busmanagementsystem.composeapp.generated.resources.label_arrival_time
import busmanagementsystem.composeapp.generated.resources.label_back_row
import busmanagementsystem.composeapp.generated.resources.label_coach_category
import busmanagementsystem.composeapp.generated.resources.label_coach_type
import busmanagementsystem.composeapp.generated.resources.label_cost_per_seat
import busmanagementsystem.composeapp.generated.resources.label_departure_date
import busmanagementsystem.composeapp.generated.resources.label_departure_time
import busmanagementsystem.composeapp.generated.resources.label_email_id
import busmanagementsystem.composeapp.generated.resources.label_from
import busmanagementsystem.composeapp.generated.resources.label_left_row
import busmanagementsystem.composeapp.generated.resources.label_organizer_name
import busmanagementsystem.composeapp.generated.resources.label_phone_number
import busmanagementsystem.composeapp.generated.resources.label_price
import busmanagementsystem.composeapp.generated.resources.label_right_row
import busmanagementsystem.composeapp.generated.resources.label_stop_number
import busmanagementsystem.composeapp.generated.resources.label_to
import busmanagementsystem.composeapp.generated.resources.label_total_seats
import busmanagementsystem.composeapp.generated.resources.label_trip_title
import busmanagementsystem.composeapp.generated.resources.logo
import busmanagementsystem.composeapp.generated.resources.ok
import busmanagementsystem.composeapp.generated.resources.phone_number
import busmanagementsystem.composeapp.generated.resources.placeholder_arrival_location
import busmanagementsystem.composeapp.generated.resources.placeholder_departure_location
import busmanagementsystem.composeapp.generated.resources.prompt_customize_seat_layout
import busmanagementsystem.composeapp.generated.resources.remove
import busmanagementsystem.composeapp.generated.resources.submit_trip
import busmanagementsystem.composeapp.generated.resources.support_text_email_id
import busmanagementsystem.composeapp.generated.resources.support_text_phone_number
import busmanagementsystem.composeapp.generated.resources.tab_lower_deck
import busmanagementsystem.composeapp.generated.resources.tab_upper_deck
import busmanagementsystem.composeapp.generated.resources.text_price_per_seat
import com.dwarshb.bms.authentication.AuthenticationViewModel
import com.dwarshb.firebase.Firebase
import com.dwarshb.firebase.onCompletion
import com.mohamedrejeb.calf.ui.datepicker.AdaptiveDatePicker
import com.mohamedrejeb.calf.ui.datepicker.rememberAdaptiveDatePickerState
import com.mohamedrejeb.calf.ui.sheet.AdaptiveBottomSheet
import com.mohamedrejeb.calf.ui.sheet.AdaptiveSheetState
import com.mohamedrejeb.calf.ui.sheet.rememberAdaptiveSheetState
import com.mohamedrejeb.calf.ui.timepicker.AdaptiveTimePicker
import com.mohamedrejeb.calf.ui.timepicker.rememberAdaptiveTimePickerState
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CreateTripScreen(viewModel: TripViewModel = viewModel { TripViewModel() },
                     authenticationViewModel: AuthenticationViewModel,
                     onTripCreated: (Trip) -> Unit,
                     onBackPressed : () -> Unit) {

    var trip by remember { mutableStateOf(Trip()) }
    var bannerUri by remember { mutableStateOf("") }

    var isLoading by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    var coroutineScope = rememberCoroutineScope()

    var steps by remember { mutableStateOf(1) }
    AnimatedContent(targetState = steps, transitionSpec = {
        slideInVertically { it } togetherWith  slideOutVertically { -it }
    }) { targetStep ->
        when (targetStep) {
            //Trip Form
            1 -> {
                createTripForm(viewModel,trip, onSubmit = {
                    trip = it
                    steps = 2
                }, onBackPressed = onBackPressed)
            }
            2 -> {
                //Trip Review
                Column(modifier = Modifier.verticalScroll(rememberScrollState())) {
                    TopAppBar(
                        title = { Text(trip.tripName) },
                        navigationIcon = {
                            IconButton(onClick = { steps = 1 }) {
                                Icon(Icons.AutoMirrored.Default.ArrowBack, contentDescription = "")
                            }
                        },
                    )

                    TripReviewLayout(trip,
                        onCustomSeatLayout = { steps = 3 },
                        onSubmit =  {
                            trip = it
                            coroutineScope.launch {
                                isLoading = true
                                authenticateOrRegister(authenticationViewModel, trip) {
                                    if (it==null) {
                                        val currentUser = Firebase.getCurrentUser()
                                        trip.organizer.uid = currentUser?.uid.toString()
                                        viewModel.createTrip(trip) {result ->
                                            if (result==trip.id) {
                                                onTripCreated(trip)
                                            } else {
                                                errorMessage = result
                                            }
                                        }
                                    } else {
                                        errorMessage = it
                                    }
                                }
                            }
                        })
                    // Show a loading indicator if necessary
                    if (isLoading) {
                        CircularProgressIndicator()
                    }

                    // Show error message if authentication fails
                    errorMessage?.let {
                        isLoading = false
                        Text(text = it, color = Color.Red)
                    }
                }
            }
            3 -> {
                //If User waants to customize bus layout
                Column {
                    TopAppBar(
                        title = { Text(trip.tripName) },
                        navigationIcon = {
                            IconButton(onClick = { steps = 1 }) {
                                Icon(Icons.AutoMirrored.Default.ArrowBack, contentDescription = "")
                            }
                        },
                    )
                    busLayoutView(trip) {
                        trip = it
                        steps = 2
                    }
                }
            }
            4 -> {
                Column {

                }
            }
        }
    }


                    // Banner upload button
//        val launcher = rememberLauncherForActivityResult(ActivityResultContracts.GetContent()) { uri ->
//            bannerUri = uri
//        }
//        Button(onClick = { launcher.launch("image/*") }) {
//            Text("Upload Banner")
//        }

//                    Button(
//                        modifier = Modifier.fillMaxWidth(), onClick = {
////                            val trip = Trip(
////                                tripName = tripTitle,
////                                departureLocation = origin,
////                                departureDate = departureDate,
////                                departureTime = departureTime,
////                                arrivalLocation = destination,
////                                arrivalDate = arrivalDate,
////                                arrivalTime = arrivalTime,
////                                costPerSeat = cost.toDoubleOrNull() ?: 0.0,
////                                coachCategory = coachCategory,
////                                coachType = coachType,
////                                totalSeats = totalSeats.toIntOrNull() ?: 0,
////                                availableSeats = totalSeats.toIntOrNull() ?: 0,
////                                bannerUri = bannerUri
////                            )
////                            viewModel.createTrip(trip)
////                            onTripCreated(trip.id)
//                        }) {
//                        Text("Create Trip")
//                    }

}

suspend fun authenticateOrRegister(
    authenticationViewModel: AuthenticationViewModel,
    trip: Trip,
    onResult: (String?) -> Unit
) {
    val email = trip.organizer.email
    val name = trip.organizer.name
    val phone = trip.organizer.phoneNumber
    if(Firebase.getCurrentUser()?.emailID!=email) {
        try {
            authenticationViewModel.login(email, phone,
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        onResult(null)
                    }

                    override fun onError(e: Exception) {
                        throw e
                    }
                }
            )
        } catch (e: Exception) {
            authenticationViewModel.signUp(
                email = email,
                password = phone,
                confirmPassword = phone,
                name = name,
                phoneNumber = phone,
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        onResult(null)
                    }

                    override fun onError(e: Exception) {
                        onResult(e.message)
                    }
                })
        }
    } else {
        onResult(null)
    }
}


@OptIn(ExperimentalLayoutApi::class)
@Composable
fun TripReviewLayout(trip: Trip,
                     displayDetailsOnly: Boolean = false,
                     onCustomSeatLayout: ()-> Unit = {},
                     onSubmit: (Trip) -> Unit = {}) {
    var customSeatLayoutChecked by remember { mutableStateOf(false) }
    Card(modifier = Modifier.fillMaxWidth().padding(16.dp),
        elevation = CardDefaults.cardElevation(8.dp)) {
        FlowRow(modifier = Modifier.align(Alignment.CenterHorizontally).padding(16.dp)) {
            Column {
                Text(stringResource(Res.string.label_from), style = MaterialTheme.typography.titleMedium)
                TextField(value = trip.departureLocation,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.LocationCity, "") })
                TextField(value = trip.departureDate,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.DateRange, "") })
                TextField(value = trip.departureTime,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.Schedule, "") })
                Spacer(modifier = Modifier.height(24.dp))
            }
            Column {
                Text(stringResource(Res.string.label_to), style = MaterialTheme.typography.titleMedium)
                TextField(value = trip.arrivalLocation,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.LocationCity, "") })
                TextField(value = trip.arrivalDate,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.DateRange, "") })
                TextField(value = trip.arrivalTime,
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.Schedule, "") })
                Spacer(modifier = Modifier.height(24.dp))
            }
            Column {
                Text(stringResource(Res.string.label_price), style = MaterialTheme.typography.titleMedium)
                TextField(value = stringResource(Res.string.text_price_per_seat, trip.costPerSeat),
                    onValueChange = {},
                    readOnly = true,
                    leadingIcon = { Icon(Icons.Default.Payment, "") })
            }
            Spacer(modifier = Modifier.height(24.dp))
            if (!displayDetailsOnly) {
                if (trip.busLayout != null) {
                    customSeatLayoutChecked = true
                    OutlinedButton(
                        modifier = Modifier.padding(16.dp).fillMaxWidth(),
                        onClick = {
                            onCustomSeatLayout()
                        }) {
                        Text(stringResource(Res.string.button_customize_seat_layout))
                    }
                } else {
                    Row {
                        Checkbox(checked = customSeatLayoutChecked,
                            onCheckedChange = { customSeatLayoutChecked = it })
                        Text(
                            stringResource(Res.string.prompt_customize_seat_layout),
                            style = MaterialTheme.typography.titleSmall,
                            modifier = Modifier.align(Alignment.CenterVertically)
                        )
                    }
                }
//                Button(modifier = Modifier.padding(16.dp).fillMaxWidth(),
//                    onClick = {}){
//                    Text("Add Payment Method ")
//                    Icon(Icons.Default.Payment,"")
//                }
                Spacer(modifier = Modifier.height(24.dp))
                val checkForCustomSeat = trip.busLayout == null && customSeatLayoutChecked
                Button(modifier = Modifier.padding(16.dp).fillMaxWidth(), onClick = {
                    if (checkForCustomSeat) {
                        onCustomSeatLayout()
                    } else {
                        onSubmit(trip)
                    }
                }) {
                    val text = if (checkForCustomSeat) Res.string.button_customize_seat_layout else Res.string.submit_trip
                    Text(stringResource(text))
                }
            }
        }
    }
}

@Composable
fun AppIconTopBar(onBackPressed: () -> Unit) {
    Row(
        modifier = Modifier.fillMaxWidth()
            .padding(16.dp), horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Image(painter = painterResource(Res.drawable.logo),"",
            modifier = Modifier.width(150.dp).height(50.dp))

        Button(onClick = { onBackPressed() }) {
            Text(stringResource(Res.string.back_to_home))
        }
    }
}
@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun createTripForm(viewModel: TripViewModel, trip: Trip,onSubmit: (Trip) -> Unit, onBackPressed: () -> Unit) {
    var tripTitle by remember { mutableStateOf(trip.tripName) }
    var origin by remember { mutableStateOf(trip.departureLocation) }
    var destination by remember { mutableStateOf(trip.arrivalLocation) }
    var cost by remember { mutableStateOf(trip.costPerSeat) }
    var coachCategory by remember { mutableStateOf(trip.coachCategory) }
    var coachType by remember { mutableStateOf(trip.coachType) }
    var totalSeats by remember { mutableStateOf(trip.totalSeats.toString()) }

    var stops by remember { mutableStateOf(listOf<String>()) } // List to hold stops

    val scope = rememberCoroutineScope()
    val adaptiveBottomSheetState = rememberAdaptiveSheetState()
    var bottomSheetVisible by remember { mutableStateOf(false) }
    var bottomSheetHeadline by remember { mutableStateOf("") }

    // Use stringResource for initial default values
    val initialDepartureDate = stringResource(Res.string.label_departure_date)
    val initialArrivalDate = stringResource(Res.string.label_arrival_date)
    val initialDepartureTime = stringResource(Res.string.label_departure_time)
    val initialArrivalTime = stringResource(Res.string.label_arrival_time)

    var departureTime by remember { mutableStateOf(initialDepartureTime) }
    var arrivalTime by remember { mutableStateOf(initialArrivalTime) }
    var departureDate by remember { mutableStateOf(initialDepartureDate) }
    var arrivalDate by remember { mutableStateOf(initialArrivalDate) }

    var showDialog by remember { mutableStateOf(false) }
    var dialogTitle : StringResource? by remember { mutableStateOf(null) }

    var organizerName by remember { mutableStateOf(trip?.organizer?.name) }
    var organizerEmail by remember { mutableStateOf(trip.organizer?.email) }
    var organizerPhone by remember { mutableStateOf(trip?.organizer?.phoneNumber) }
    val currentUser = Firebase.getCurrentUser()
    viewModel.getAppUser{
        if (it!=null) {
            organizerName = it.name
            organizerEmail = it.email
            organizerPhone = it.phoneNumber
        }
    }
    Column(modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState())) {
        AppIconTopBar {
            onBackPressed()
        }
        Card(
            modifier = Modifier.align(Alignment.CenterHorizontally)
                .padding(start = 24.dp, end = 24.dp, top = 24.dp),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.elevatedCardElevation(16.dp)
        ) {
            Column(modifier = Modifier.padding(16.dp)) {
                Text(
                    stringResource(Res.string.create_new_trip_title), style = MaterialTheme.typography.headlineMedium,
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                )
                Text(
                    stringResource(Res.string.create_new_trip_subtitle),
                    style = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.padding(bottom = 16.dp)
                        .align(Alignment.CenterHorizontally)
                )
                OutlinedTextField(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    value = tripTitle,
                    onValueChange = { tripTitle = it },
                    label = { Text(stringResource(Res.string.label_trip_title)) })
                FlowRow(modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center,
                    verticalArrangement = Arrangement.SpaceEvenly) {
                    Column {
                        OutlinedTextField(
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                            value = origin,
                            onValueChange = { origin = it },
                            label = { Text(stringResource(Res.string.label_from)) },
                            placeholder = {
                                Text(stringResource(Res.string.placeholder_departure_location))
                            })
                        OutlinedButton(
                            shape = RectangleShape,
                            modifier = Modifier.align(Alignment.CenterHorizontally)
                                .padding(top = 12.dp, end = 16.dp, start = 16.dp),
                            onClick = {
                                bottomSheetVisible = true
                                bottomSheetHeadline = initialDepartureDate
                            }) {
                            Icon(Icons.Default.DateRange, contentDescription = "")
                            Text(departureDate, modifier = Modifier.padding(start = 12.dp))
                        }
                        OutlinedButton(
                            shape = RectangleShape,
                            modifier = Modifier.align(Alignment.CenterHorizontally)
                                .padding(top = 12.dp, end = 16.dp, start = 16.dp),
                            onClick = {
                                bottomSheetVisible = true
                                bottomSheetHeadline = initialDepartureTime
                            }) {
                            Icon(Icons.Default.Schedule, contentDescription = "")
                            Text(departureTime, modifier = Modifier.padding(start = 12.dp))
                        }
                    }
                    Column {
                        OutlinedTextField(
                            modifier = Modifier.align(Alignment.CenterHorizontally),
                            value = destination,
                            onValueChange = { destination = it },
                            label = { Text(stringResource(Res.string.label_to)) },
                            placeholder = { Text(stringResource(Res.string.placeholder_arrival_location)) })
                        OutlinedButton(
                            shape = RectangleShape,
                            modifier = Modifier.align(Alignment.CenterHorizontally)
                                .padding(top = 12.dp, end = 16.dp, start = 16.dp),
                            onClick = {
                                bottomSheetVisible = true
                                bottomSheetHeadline = initialArrivalDate
                            }) {
                            Icon(Icons.Default.DateRange, contentDescription = "")
                            Text(arrivalDate, modifier = Modifier.padding(start = 12.dp))
                        }
                        OutlinedButton(
                            shape = RectangleShape,
                            modifier = Modifier.align(Alignment.CenterHorizontally)
                                .padding(top = 12.dp, end = 16.dp, start = 16.dp),
                            onClick = {
                                bottomSheetVisible = true
                                bottomSheetHeadline = initialArrivalTime
                            }) {
                            Icon(Icons.Default.Schedule, contentDescription = "")
                            Text(arrivalTime, modifier = Modifier.padding(start = 12.dp))
                        }
                    }
                }
                // Display stop fields dynamically
                stops.forEachIndexed { index, stop ->
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        OutlinedTextField(
                            value = stop,
                            onValueChange = { newValue ->
                                stops = stops.toMutableList().apply { set(index, newValue) }
                            },
                            label = { Text(stringResource(Res.string.label_stop_number, index + 1)) },
                            modifier = Modifier.weight(1f)
                        )
                        IconButton(onClick = {
                            stops = stops.toMutableList().apply { removeAt(index) }
                        }) {
                            Icon(
                                imageVector = Icons.Default.Close,
                                contentDescription = stringResource(Res.string.remove)
                            )
                        }
                    }
                }

                OutlinedButton(modifier = Modifier
                    .padding(top = 16.dp, end = 16.dp, start = 16.dp)
                    .align(Alignment.CenterHorizontally), onClick = {
                    stops = stops + "" // Add an empty stop field
                }) {
                    Icon(Icons.Default.AddCircle, contentDescription = "Add Stop")
                    Text(stringResource(Res.string.button_add_stop))
                }
                Text(
                    stringResource(Res.string.hint_add_stops),
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    style = MaterialTheme.typography.bodySmall
                )
                Spacer(modifier = Modifier.height(24.dp))
                FlowRow(modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center) {
                    CustomDropdownMenu(modifier = Modifier,
                        items = listOf(stringResource(Res.string.coach_category_ac),
                            stringResource(Res.string.coach_category_non_ac)),
                        label = stringResource(Res.string.label_coach_category),
                        selected = coachCategory,
                        onSelected = {
                            coachCategory = it
                        })
                    CustomDropdownMenu(modifier = Modifier,
                        items = listOf(
                            stringResource(Res.string.coach_type_sleeper),
                            stringResource(Res.string.coach_type_seater)),
                        label = stringResource(Res.string.label_coach_type),
                        selected = coachType,
                        onSelected = {
                            coachType = it
                        })
                    OutlinedTextField(
                        modifier = Modifier,
                        value = cost,
                        onValueChange = { cost = it },
                        label = { Text(stringResource(Res.string.label_cost_per_seat)) })

                    OutlinedTextField(
                        modifier = Modifier,
                        value = totalSeats,
                        onValueChange = { totalSeats = it },
                        label = { Text(stringResource(Res.string.label_total_seats)) })
                    if (currentUser == null) {
                        OutlinedTextField(
                            value = organizerName.toString(),
                            onValueChange = { organizerName = it },
                            label = { Text(stringResource(Res.string.label_organizer_name)) })
                        OutlinedTextField(
                            value = organizerPhone.toString(),
                            onValueChange = { organizerPhone = it },
                            label = { Text(stringResource(Res.string.phone_number)) },
                            supportingText = { Text(stringResource(Res.string.support_text_phone_number)) })
                        OutlinedTextField(
                            value = organizerEmail.toString(),
                            onValueChange = { organizerEmail = it },
                            label = { Text(stringResource(Res.string.email)) },
                            supportingText = { Text(stringResource(Res.string.support_text_email_id)) })
                    }
                }
                Spacer(modifier = Modifier.height(24.dp))
                Button(
                    modifier = Modifier.fillMaxWidth(), onClick = {
                        val trip = Trip(
                            tripName = tripTitle,
                            departureLocation = origin,
                            departureDate = departureDate,
                            departureTime = departureTime,
                            arrivalLocation = destination,
                            arrivalDate = arrivalDate,
                            arrivalTime = arrivalTime,
                            costPerSeat = cost,
                            coachCategory = coachCategory,
                            coachType = coachType,
                            totalSeats = totalSeats.toIntOrNull() ?: 0,
                            availableSeats = totalSeats.toIntOrNull() ?: 0,
                            organizer = AppUser(
                                organizerEmail.toString(),
                                organizerName.toString(),
                                organizerPhone.toString(),"",""),
                            bannerUri = ""
                        )
                        if (trip.departureDate==initialDepartureDate) {
                            showDialog = true
                            dialogTitle = Res.string.label_departure_date
                        } else if (trip.departureTime==initialDepartureTime) {
                            showDialog = true
                            dialogTitle = Res.string.label_departure_time
                        } else if (trip.arrivalDate==initialArrivalDate) {
                            showDialog = true
                            dialogTitle = Res.string.label_arrival_date
                        } else if (trip.arrivalTime==initialArrivalTime) {
                            showDialog = true
                            dialogTitle = Res.string.label_arrival_time
                        } else {
                            validateTrip(trip) { isValid, message ->
                                if (isValid) {
                                    onSubmit(trip)
                                } else if (message!=null){
                                    showDialog = true
                                    dialogTitle = message
                                }
                            }
                        }
                    }) {
                    Text(stringResource(Res.string.button_next_steps))
                }

                if (showDialog) {
                    BasicAlertDialog(onDismissRequest = {
                        showDialog = false
                    }) {
                        Surface(
                            modifier = Modifier.wrapContentWidth().wrapContentHeight(),
                            shape = MaterialTheme.shapes.large,
                            tonalElevation = AlertDialogDefaults.TonalElevation
                        ) {
                            Column(modifier = Modifier.padding(16.dp)) {
                                Text(
                                    stringResource(Res.string.error), style = MaterialTheme.typography.titleMedium,
                                    color = Color.Red)
                                Spacer(modifier = Modifier.height(24.dp))
                                Text(buildAnnotatedString {
                                    append("Invalid Data in ")
                                    pushStyle(SpanStyle(fontWeight = FontWeight.Bold))
                                    append(stringResource(dialogTitle!!))
                                    pop()
                                    append(" field.")
                                })
                                Spacer(modifier = Modifier.height(24.dp))
                                Button(
                                    modifier = Modifier.fillMaxWidth(),
                                    onClick = {
                                    showDialog = false
                                }) {
                                    Text(stringResource(Res.string.ok))
                                }
                            }
                        }
                    }
                }

                if (bottomSheetVisible) {
                    BottomSheetState(bottomSheetHeadline, adaptiveBottomSheetState, scope) {
                        bottomSheetVisible = false
                        if (!it.contains(":")) {
                            if (bottomSheetHeadline == initialDepartureDate) {
                                departureDate = it
                            } else {
                                arrivalDate = it
                            }
                        } else if (bottomSheetHeadline == initialDepartureTime) {
                            departureTime = it
                        } else if(bottomSheetHeadline == initialArrivalTime){
                            arrivalTime = it
                        }
                    }
                }
                if (adaptiveBottomSheetState.isVisible && !bottomSheetVisible) {
                    scope.launch { adaptiveBottomSheetState.hide() }.invokeOnCompletion {
                        if (adaptiveBottomSheetState.isVisible) {
                            bottomSheetVisible = false
                        }
                    }
                }
            }
        }
    }
}

fun validateTrip(trip: Trip, onResult: (Boolean,StringResource?) -> Unit) {
    var dialogFor : StringResource? = null
    var isValid = false
    if (trip.tripName.trim().isEmpty()) {
        dialogFor = Res.string.label_trip_title
    } else if (trip.departureLocation.trim().isEmpty()) {
        dialogFor = Res.string.placeholder_departure_location
    } else if (trip.arrivalLocation.trim().isEmpty()) {
        dialogFor = Res.string.placeholder_arrival_location
    } else if (trip.coachType.isEmpty()) {
        dialogFor = Res.string.label_coach_type
    } else if (trip.coachCategory.isEmpty()) {
        dialogFor = Res.string.label_coach_category
    } else if (trip.costPerSeat.trim().isEmpty()) {
        dialogFor = Res.string.label_cost_per_seat
    } else if(trip.totalSeats==0){
        dialogFor = Res.string.label_total_seats
    } else if(trip.organizer.name.toString().trim().isEmpty()) {
        dialogFor = Res.string.label_organizer_name
    } else if (trip.organizer.phoneNumber.toString().trim().isEmpty()) {
        dialogFor = Res.string.label_phone_number
    } else if (trip.organizer.email.trim().isEmpty()) {
        dialogFor = Res.string.label_email_id
    } else {
        isValid = true
    }
    onResult(isValid,dialogFor)
}

@Composable
fun busLayoutView(trip: Trip, updatedTrip: (Trip)-> Unit) {
    var selectedTab by remember { mutableStateOf(0) }
    var leftSeats by remember { mutableStateOf("2") }
    var rightSeats by remember { mutableStateOf("3") }
    var backSeats by remember { mutableStateOf("5") }
    var coachType by remember { mutableStateOf(trip.coachType) }

    var selectedSeat by remember { mutableStateOf("") }
    var selectedSeatList = remember { mutableStateListOf<String>() }

    var showSeatDialog by remember { mutableStateOf(false) }

    if (trip.busLayout!=null) {
        leftSeats = trip.busLayout?.leftRow.toString()
        rightSeats = trip.busLayout?.rightRow.toString()
        backSeats = trip.busLayout?.backRow.toString()
        selectedSeatList = trip.selectedSeats as SnapshotStateList<String>
    }

    CustomDropdownMenu(modifier = Modifier.padding(8.dp),
        items = listOf(stringResource(Res.string.coach_type_sleeper),
            stringResource(Res.string.coach_type_seater)
        ),
        label = stringResource(Res.string.label_coach_type),
        selected = coachType,
        onSelected = {
            coachType = it
            selectedSeatList.clear()
        })
    Row {

        OutlinedTextField(
            value = leftSeats,
            readOnly = true,
            onValueChange = { leftSeats = it },
            leadingIcon = {
                IconButton(onClick = {
                    if (leftSeats.toInt()>1) {
                        leftSeats = (leftSeats.toInt()-1).toString()
                    }
                }){
                    Text("-", style = MaterialTheme.typography.titleLarge)
                }
            },
            trailingIcon = {
                IconButton(onClick = {
                    if (leftSeats.toInt()<3) {
                        leftSeats = (leftSeats.toInt()+1).toString()
                    }
                }){
                    Text("+", style = MaterialTheme.typography.titleLarge)
                }
            },
            label = { Text(stringResource(Res.string.label_left_row)) },
            modifier = Modifier.weight(1f).padding(8.dp)
        )
        OutlinedTextField(
            value = rightSeats,
            readOnly = true,
            onValueChange = { rightSeats = it },
            leadingIcon = {
                IconButton(onClick = {
                    if (rightSeats.toInt()>1) {
                        rightSeats = (rightSeats.toInt()-1).toString()
                    }
                }){
                    Text("-", style = MaterialTheme.typography.titleLarge)
                }
            },
            trailingIcon = {
                IconButton(onClick = {
                    if (rightSeats.toInt()<3) {
                        rightSeats = (rightSeats.toInt()+1).toString()
                    }
                }){
                    Text("+", style = MaterialTheme.typography.titleLarge)
                }
            },
            label = { Text(stringResource(Res.string.label_right_row)) },
            modifier = Modifier.weight(1f).padding(8.dp)
        )
        OutlinedTextField(
            value =  backSeats,
            readOnly = true,
            onValueChange = {backSeats = it},
            leadingIcon = {
                IconButton(onClick = {
                    if (backSeats.toInt()>1) {
                        backSeats = (backSeats.toInt()-1).toString()
                    }
                }){
                    Text("-", style = MaterialTheme.typography.titleLarge)
                }
            },
            trailingIcon = {
                IconButton(onClick = {
                    if (backSeats.toInt()<(rightSeats.toInt()+leftSeats.toInt()+1)) {
                        backSeats = (backSeats.toInt()+1).toString()
                    }
                }){
                    Text("+", style = MaterialTheme.typography.titleLarge)
                }
            },
            label = { Text(stringResource(Res.string.label_back_row)) },
            modifier = Modifier.weight(1f).padding(8.dp)
        )
    }
    Spacer(modifier = Modifier.height(16.dp))

    val titles = listOf(stringResource(Res.string.tab_upper_deck,
        stringResource(Res.string.tab_lower_deck)
    ))
    if (coachType == stringResource(Res.string.coach_type_sleeper)) {
        TabRow(
            selectedTabIndex = selectedTab
        ) {
            titles. forEachIndexed { index, s ->
                Tab(
                    selected = selectedTab==index,
                    onClick = { selectedTab = index},
                    text = { Text(s) }
                )
            }
        }
    }
    SeatLayout(seats = List(trip.totalSeats) { BusSeat(it.toString(),coachType) },
        coachType = coachType,
        deck= if (coachType== stringResource(Res.string.coach_type_sleeper)) titles[selectedTab].first().toString() else "",
        leftSeats = leftSeats.toInt(),
        rightSeats = rightSeats.toInt(),
        backSeats = if(backSeats.isNotEmpty()) backSeats.toInt() else 0,
        selectedSeats = selectedSeatList,
        onSeatSelected = {
                selectedSeat = it
                showSeatDialog = true
            },
        confirmSeatLayout = {busLayout,selectedSeats ->
            trip.coachType = coachType
            trip.availableSeats = trip.totalSeats-selectedSeatList.size
            trip.busLayout = busLayout
            trip.selectedSeats = selectedSeats
            updatedTrip(trip)
        })

    val lockSeatLabel = stringResource(Res.string.dialog_action_lock_seat)
    val unlockSeatLabel = stringResource(Res.string.dialog_action_unlock_seat)

    if (showSeatDialog) {
        var action = lockSeatLabel
        if (selectedSeatList.contains(selectedSeat)) {
            action = unlockSeatLabel
        }
        seatDialog(action,seatNumber = selectedSeat) {
            showSeatDialog = false
            if (it==lockSeatLabel) {
                selectedSeatList.add(selectedSeat)
            } else {
                selectedSeatList.remove(selectedSeat)
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun BottomSheetState(headline: String,sheetState: AdaptiveSheetState,scope: CoroutineScope, onValueReturned:(String) -> Unit) {
    val adaptiveDatePickerState = rememberAdaptiveDatePickerState()
    val adaptiveTimePickerState = rememberAdaptiveTimePickerState()
    var resultValue by remember { mutableStateOf("") }
    var dateColor by remember { mutableStateOf(Color.Green) }

    AdaptiveBottomSheet(
        onDismissRequest = {
            onValueReturned(resultValue)
        },
        adaptiveSheetState = sheetState,
    ) {
        LaunchedEffect(adaptiveDatePickerState.selectedDateMillis) {
            var selectedDate = adaptiveDatePickerState.selectedDateMillis
            if (selectedDate!=null) {
                if((selectedDate/1000)>Clock.System.now().epochSeconds) {
                    dateColor = Color.Green
                    resultValue = selectedDate.let { Utils.getDate(it) }.toString()
                } else {
                    dateColor = Color.Red
                }
            }
        }
        LaunchedEffect(adaptiveTimePickerState.hour, adaptiveTimePickerState.minute) {
            val hour =
                if (adaptiveTimePickerState.hour < 10) "0${adaptiveTimePickerState.hour}"
                else adaptiveTimePickerState.hour
            val minute =
                if (adaptiveTimePickerState.minute < 10) "0${adaptiveTimePickerState.minute}"
                else adaptiveTimePickerState.minute
            resultValue = "$hour:$minute"
        }
        if (headline.contains(stringResource(Res.string.content_desc_date))) {
            Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Text(headline, modifier = Modifier.padding(16.dp).weight(1f))
                IconButton(onClick = {
                    scope.launch {
                        sheetState.hide()
                        onValueReturned(resultValue)
                    }
                }) {
                    Icon(Icons.Filled.CheckCircle, contentDescription = "")
                }
            }
            AdaptiveDatePicker(
                modifier = Modifier.padding(24.dp),
                showModeToggle = false,
                state = adaptiveDatePickerState,
                colors = DatePickerDefaults.colors(selectedDayContainerColor = dateColor)
            )
        } else {
            AdaptiveTimePicker(
                modifier = Modifier.padding(24.dp),
                state = adaptiveTimePickerState
            )
        }
    }
}
